import React, { useState } from "react";
import { Field } from "formik";

const PasswordField = ({ name, placeholder = "Password", ...props }) => {
  const [show, setShow] = useState(false);

  return (
    <div className="input-group input-group-merge">
      <Field
        type={show ? "text" : "password"}
        name={name}
        id={`form-${name}`}
        className="form-control form-control-lg"
        placeholder={placeholder}
        maxLength="512"
        tabindex="1"
        required
        {...props}
      />
      <div className="input-group-append">
        <span
          className="input-group-text"
          style={{ cursor: "pointer" }}
          onClick={() => setShow(!show)}
        >
          <i className={`fa ${show ? "fa-eye-slash" : "fa-eye"}`} />
        </span>
      </div>
    </div>
  );
};

export default PasswordField;